import { useCallback, useState } from "react";
import { useSnackbar } from "notistack";
import {
  fetchInsurerContacts,
  createInsurerContact,
  updateInsurerContact,
  deleteInsurerContact,
  makeInsurerContactDefault,
} from "@accredo/fe-shared/services/insurerContactService.js";

export function useInsurerContactActions(insurer_id) {
  const { enqueueSnackbar } = useSnackbar();
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const load = useCallback(() => {
    setIsLoading(true);
    return fetchInsurerContacts(insurer_id)
      .then((res) => {
        setContacts(res.data ?? []);
        setHasLoaded(true);
      })
      .catch(() =>
        enqueueSnackbar("Kontakte konnten nicht geladen werden", {
          variant: "error",
        })
      )
      .finally(() => setIsLoading(false));
  }, [insurer_id, enqueueSnackbar]);

  const create = async (payload) => {
    const result = await createInsurerContact(insurer_id, payload);
    await load();
    return result;
  };

  const update = async (contact_id, payload) => {
    const result = await updateInsurerContact(insurer_id, contact_id, payload);
    await load();
    return result;
  };

  const makeDefault = async (contact_id) => {
    const result = await makeInsurerContactDefault(insurer_id, contact_id);
    await load();
    return result;
  };

  const remove = async (contact_id) => {
    await deleteInsurerContact(insurer_id, contact_id);
    await load();
  };

  return { contacts, isLoading, hasLoaded, load, create, update, makeDefault, remove };
}
